import { ConfigProvider, DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker/index';
import dayjs from 'dayjs';

export interface DateRangePickPcProps extends RangePickerProps {}

export const DateRangePickPc = (props: DateRangePickPcProps) => {
  const { style = {}, format = 'YYYY-MM-DD HH:mm:ss', value, ...reset } = props;
  const startValue = value?.[0] ? dayjs(value[0]) : undefined;
  const endValue = value?.[1] ? dayjs(value[1]) : undefined;
  return (
    <DatePicker.RangePicker
      value={[startValue, endValue]}
      style={{width:'100%',...style}}
      {...reset }
    />
  )
};
